import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './config/pdf'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://eacc94d4d16c4018c3a29f397b095201@o4508689871405056.ingest.us.sentry.io/4508691003080704",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance and error monitoring
  tracesSampleRate: 0.05,
  // Set tracePropagationTargets to your actual API domains for production
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/.*\.work-and-safety\.initia-digital\.co\.nz/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
  // Environment and release tracking
  environment: import.meta.env.VITE_ENV_LOWER || 'development',
  release: process.env.PACKAGE_VERSION
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
